import { type IconProps } from './types'
/**
 * ![Zyjianshao](data:image/svg+xml;base64,PHN2ZyB0PSIxNzUxMjY5Mzg5OTQ0IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjI5NTYxIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiPjxwYXRoIGQ9Ik04MDAgNTEyYTQxLjYgNDEuNiAwIDAgMS00MS42IDQxLjZoLTQ5Mi44YTQxLjYgNDEuNiAwIDEgMSAwLTgzLjJoNDkyLjhhNDEuNiA0MS42IDAgMCAxIDQxLjYgNDEuNnoiIHAtaWQ9IjI5NTYyIj48L3BhdGg+PC9zdmc+)
 */
export const ZyjianshaoIcon = ({ color = 'currentColor', size = 16, ...props }: IconProps) => {
  return (
    <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width={size} height={size} {...props}>
      <path
        d="M800 512a41.6 41.6 0 0 1-41.6 41.6h-492.8a41.6 41.6 0 1 1 0-83.2h492.8a41.6 41.6 0 0 1 41.6 41.6z"
        fill={color}
      ></path>
    </svg>
  )
}
